
export const OTHER_CKBX_VAL = "other";
export const OTHER_DISPLAY_SEP = " - ";

//format for storing value when other is checked is "other - thefreetextenteredbyuser"
export function isOtherChecked(values){
  let isOtherChecked = false;
  if(values && Array.isArray(values) && values.length){
    isOtherChecked = (values.findIndex( (value) => value.startsWith(OTHER_CKBX_VAL)) > -1)
  }
  else if (typeof values === 'string'){
    isOtherChecked = (values.startsWith(OTHER_CKBX_VAL));
  }
  return isOtherChecked;
}

export function findOtherIndex(values){
  let otherIndex = -1;
  if(values && values.length){
    otherIndex = values.findIndex((activity) => activity.startsWith(OTHER_CKBX_VAL));
  }
  return otherIndex;
}

export function getOtherEntryFromString(value){
  let otherEntry = "";
  if( value && value.startsWith(OTHER_CKBX_VAL)){
    otherEntry = value.slice(OTHER_CKBX_VAL.length + OTHER_DISPLAY_SEP.length);
  }
  return otherEntry;
}

export function getOtherEntryFromArray(values){
  let otherEntry = "";
  let otherIndex = -1;
  if(values && values.length){
    otherIndex = values.findIndex((activity) => activity.startsWith(OTHER_CKBX_VAL));
  }

  if (otherIndex > -1){
    otherEntry = values[otherIndex].slice(OTHER_CKBX_VAL.length + OTHER_DISPLAY_SEP.length);
  }
  return otherEntry;
}

